// extracted by mini-css-extract-plugin
export default {"mn-associate-task-content":"index_mn-associate-task-content__DKluc"};